<!--
    @Author : Luo
    @Time   : 2020/4/16 10:34
    icon of select down
-->
<template>
  <span class="select_down">
    <svg :class="svgClass" aria-hidden="true" @click="_click">
      <use :xlink:href="iconName"></use>
    </svg>
  </span>
</template>

<script>
export default {
  name: 'svgIcon',
  data () { return {} },
  props: {
    iconClass: { // the name of svg`s file（svg文件的名字）
      type: String,
      required: true
    },
    className: { // style
      type: String,
      default: ''
    },
    activeName: String
  },
  computed: {
    iconName: function () {
      return `#icon-${this.iconClass}` // see svg`s module rule options symbolId in webpack.base.conf.js（格式请看webpack.base.conf.js文件里svg模块的symbolId）
    },
    svgClass: function () {
      return 'svg-icon ' +
        (this.className ? this.className + ' ' +
          (this.activeName ? this.activeName + '_hover' : '')
          : '')
    }
  },
  methods: {
    _click: function (event) {
      event.stopPropagation()
      this.$emit('svgClick', {el: this.$el, event: event, pos: this.$props.iconClass, hint: 'his is click event of svg'})
    }
  },
  mounted: function () {}
}
</script>

<style scoped>
.select_down {display: block;line-height: 0.7}
.svg_icon {fill: currentColor;overflow: hidden;line-height: 1;cursor: pointer}
.svg_icon_special {width: 3.75em;height: 2.125em}
.svg_icon_44 {width: 2.75em;height: 2.75em}
.svg_icon_24 {width: 2.3335em;height: 2.3335em}
.svg_icon_lg {width: 2em;height: 2em}
.svg_icon_md {width: 1.875em;height: 1.875em}
.svg_icon_sm {width: 1.5em;height: 1.5em}
.svg_icon_14 {width: 1.25em;height: 1.25em}
.svg_icon_xs {width: 1em;height: 1em}
.color_255 {fill: rgba(255, 255, 255, 1)}
.color_170 {fill: rgba(170, 170, 170, 1)}
.color_174 {fill: rgba(173, 174, 174, 1)}
.color_102 {fill: rgba(102, 102, 102, 1)}
.color_219 {fill: rgba(219, 219, 219, 1)}
.color_202 {fill: rgba(202, 202, 202, 1)}
.color_red {fill: rgba(234, 55, 55, 1)}
.color_green {fill: rgba(51, 239, 130, 1)}
.color_grey {fill: rgba(144, 144, 144, 1)}
.sort_hover, .filter_hover, .svg_hover {cursor: pointer}
.sort_hover:hover, .filter_hover:hover, .svg_active, .svg_hover:hover {fill: rgba(76, 139, 255, 1)}
</style>



// WEBPACK FOOTER //
// src/components/icon-svg/index.vue